import axios from 'axios';
import router from '@/router';

const AdminHttpClient = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API + '/admin'
});

AdminHttpClient.interceptors.request.use(config => {
    const token = localStorage.getItem('admin_token');
    if (token) config.headers = { 'Authorization': token };
    return config;
}, err => Promise.reject(err));

AdminHttpClient.interceptors.response.use(
    response => response,
    error => {
        const code = error.response?.data?.error;
        if (code === 'token_expired' || code === 'invalid_token' || error.response?.status === 401) {
            localStorage.removeItem('admin_token');
            const uuid = process.env.VUE_APP_ADMIN_UUID;
            router.push(`/${uuid}/login`);
        }
        return Promise.reject(error);
    }
);

export default AdminHttpClient;
